// import Worker from './extract.worker.js';

const extractVersionFromArrayBuffer = (arrayBuffer: ArrayBuffer): Promise<string> => {
  return new Promise((resolve, reject) => {
    // const worker = new Worker(new URL('./extract.worker.js', import.meta.url));
    const Worker = require('./extract.worker.js');
    const worker = new Worker();
    worker.postMessage(arrayBuffer);

    worker.onmessage = (event: any) => {
      worker.terminate();
      resolve(event.data);
    };

    worker.onerror = (event: any) => {
      worker.terminate();
      reject(event);
    };
  });
};

export { extractVersionFromArrayBuffer };
